import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1185444561/src/web/app/(publicScreens)/producer/[slug]/ProducerScreenClient.tsx");
